/* eslint-disable jsx-a11y/anchor-is-valid */
import { useCallback, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import { ConnectionsViewModel as Model } from 'app/dashboard/model/dashboard.model'
import LoadingSpinner from 'common/partials/LoadingSpinner'
import { DashboardService as Service } from '../../services/dashboard.service'
import en from '../../i18n/en-us.json';
import pt from '../../i18n/pt-br.json';
import es from '../../i18n/es-es.json';
import DashboardContext from 'app/dashboard/context/dashboard.context'
import { UserMessages } from 'common/enums/UserMessages'
import { useWebSocket } from 'common/helpers/signalR/context/signalR'

type Props = {
    className: string;
}

export function ConnectedAgents(props: Props) {
    i18next.addResourceBundle('us', 'translation', en);
    i18next.addResourceBundle('br', 'translation', pt);
    i18next.addResourceBundle('es', 'translation', es);
    const { t } = useTranslation();
    const connection = useWebSocket();
    const [isLoading, setIsLoading] = useState(false);

    const initialData: Model = {
        active: 0,
        inactive: 0,
        percentActive: 0,
        percentInactive: 0,
        totalQuantity: 0,
    }

    const [connectedAgents, setConnectedAgents] = useState<Model>(initialData);

    const fetchConnections = async () => {
        setIsLoading(true);
        const response = await Service.getConnections();
        if (response && !response.hasErrors) {
            setConnectedAgents(response.data);
        }
        setIsLoading(false);
    }

    const loadConnections = useCallback(() => fetchConnections(), []);

    useEffect(() => {
        loadConnections();
        if (!connection) return;
        const listeners: Function[] = [];
        listeners.push(connection.onAgentConnected(loadConnections));
        listeners.push(connection.onAgentDisconnected(loadConnections));
        return () => listeners.forEach(l => l());
    }, [connection, loadConnections]);

    return (
        <div className={`card ${props.className}`}>
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-start">
                    {
                        isLoading
                            ? <LoadingSpinner loading={isLoading} align="start" />
                            : <span className="fw-semibold fs-2x text-gray-800 lh-1 ls-n2">{connectedAgents.active}</span>
                    }
                    <span><i className={`fa-solid fa-plug fs-2x ${connectedAgents.active > 0 ? 'text-success' : undefined}`}></i></span>
                </div>
                <div>
                    <span className="fw-semibold fs-6 text-gray-400">{t('connectedAgents.title')}</span>
                </div>
            </div>
        </div>
    )
}